import http from 'axios'
import config from 'src/config'
import { IVoice } from './types'
import { IVoicesState } from './Voices.reducer'
// import showConfirmModal from 'features/Modal/ConfirmModal/ConfirmModal.action'
// import { push } from 'react-router-redux'

type IGetState = () => { voices: IVoicesState }

export const getSamples = ({
  filter = {},
  cacheKey,
}: {
  filter: { genderAndAge?: string; language?: string }
  cacheKey: string
}) => ({
  type: 'VOICE/GET_SAMPLES',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/voice/samples`,
    params: {
      genderAndAge: filter.genderAndAge,
      language: filter.language,
    },
  }),
  meta: {
    cacheKey,
  },
})

export const getQuote = ({
  script,
  talentID,
}: {
  script: { [key: string]: string }
  talentID: string
}) => ({
  type: 'VOICE/GET_QUOTE',
  payload: http({
    method: 'POST',
    url: `${config.api.main}/api/v1/voice/quote`,
    data: {
      talentID,
      script,
    },
  }),
})

export const getVoices = ({ page = 1, cacheKey }) => (dispatch, getState: IGetState) => {
  const isLoading = getState().voices.list[cacheKey] && getState().voices.list[cacheKey].loading
  if (!isLoading) {
    dispatch({
      type: 'VOICE/GET_VOICE_PROJECTS',
      payload: http({
        method: 'GET',
        url: `${config.api.main}/api/v1/voice`,
        params: {
          page,
          limit: '20',
        },
      }),
      meta: {
        cacheKey,
      },
    })
  }
}

export const getVoice = ({ voiceId }) => ({
  type: 'VOICE/GET_VOICE_PROJECT',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/voice/${voiceId}`,
  }),
  meta: {
    cacheKey: voiceId,
  },
})

export const createVoice = ({
  title,
  talentID,
  script,
  ban,
}: {
  title: string
  talentID: string
  script: {
    [key: string]: string
  }
  ban: string
}): Promise<{ value: { data: IVoice } }> =>
  ({
    type: 'VOICE/CREATE_VOICE_PROJECT',
    payload: http({
      method: 'POST',
      url: `${config.api.main}/api/v1/voice`,
      data: {
        title,
        talentID,
        script,
        ban,
      },
    }),
  } as any)



// WEBPACK FOOTER //
// src/features/Voices/Voices.actions.ts